import Splide from '@splidejs/splide';

export default class HeroCarousel {
	constructor() {
		this.init();
	}

	init() {
		let heroCarouselElement = document.querySelectorAll( '[data-hero-carousel="element"]' );

		heroCarouselElement.forEach( ( element ) => {
			let carousel = new Splide( element, {
                type: 'fade',
				autoplay: true,
                interval: 5000,
                rewind: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                arrows: false
            } ).mount();
		} );
	}
}
